__turbopack_context__.v({
  "iconMoon": "themetoggle-module__ZLbzMW__iconMoon",
  "iconSun": "themetoggle-module__ZLbzMW__iconSun",
  "toggle": "themetoggle-module__ZLbzMW__toggle",
});
